const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGpoAm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 538.84 119.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.39,35.07a52.22,52.22,0,0,1-13.73,1.63c-9.45,0-20.38-4.78-20.38-18.2S147.68,0,160.69,0C163,0,168,.25,171.42,1.58l-.76,7.72A18,18,0,0,0,162,7c-7.68,0-14,3.21-14,11.49,0,7,4.93,11.18,11.84,11.18a8.24,8.24,0,0,0,3.36-.61v-7H157.7V15.35h14.69Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.09,16.93a10.38,10.38,0,0,0-3.1-.31c-4.27,0-6.66,3.1-6.66,8.29V36.09h-9.15V9.61h8.34v4.88h.1c1.57-3.36,3.86-5.49,7.83-5.49a19.87,19.87,0,0,1,3.1.3Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.45,36.09h-8.34V31.21H220c-1.83,3.81-5.49,5.49-9.66,5.49-7.21,0-10.11-5.08-10.11-10.57V9.61h9.15V22.42c0,5,1.73,6.65,4.22,6.65,3.76,0,5.69-2.59,5.69-8.28V9.61h9.15Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.43,9.61h8.44v4.77h.1C243.8,10.67,247.66,9,251.83,9c7.32,0,11.34,7,11.34,13.36,0,7.83-4.22,14.34-12.1,14.34-3.2,0-6.66-1.17-8.39-4.32h-.1V46.76h-9.15ZM248.17,16c-3.35,0-5.59,2.95-5.59,6.91s2.54,6.76,5.59,6.76c3.46,0,5.54-2.89,5.54-7.11C253.71,19.06,251.73,16,248.17,16Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.81,22.87c0-8.79,6.66-13.87,15.4-13.87s15.4,5.08,15.4,13.87S290,36.7,281.21,36.7,265.81,31.62,265.81,22.87Zm21.35,0c0-4-1.73-7.47-6-7.47s-5.95,3.51-5.95,7.47,1.73,7.42,5.95,7.42S287.16,26.79,287.16,22.87Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.59,52.47a9.65,9.65,0,0,1,4.29,1.11c2.22,1.05,4.81,2.26,8.06,3.81,0,0,5.25-3.72,5.53-3.91a2.75,2.75,0,0,1,4.06.76A100.41,100.41,0,0,1,114,72.59a2.06,2.06,0,0,1-1.37,2.55,26.1,26.1,0,0,1-3.42.58c-1.9.24-1.87,1.77-1.87,2.71,0,1.14,0,8.88,0,11.52A7,7,0,0,1,100,96.88H86a9.6,9.6,0,0,1-9.57-9.21c0-3.13,0-24.91,0-27.35a8.1,8.1,0,0,1,8.11-7.85",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.46,96.88H17v5.06H70.35a26.83,26.83,0,0,0,1.93-9.42c0-.26,0-34.29,0-34.29,0-2.7,1.1-7.26,6.66-8.48l.47-.1c15.76-3.72,32-.33,41.14,3.62,1.66.79,2-.52,2-1.08a16.83,16.83,0,0,0-16.44-17A28.38,28.38,0,0,0,90.7,39a.47.47,0,0,1-.55-.19,23,23,0,0,0-8.94-5.1.52.52,0,0,1,0-1,71.6,71.6,0,0,1,18.57.54c.69.12,1.21-.29.93-.94-.2-.48-.38-.71-.73-1.46a8.24,8.24,0,0,0-5.17-4A118.19,118.19,0,0,0,67.36,23.4a133.18,133.18,0,0,0-25.81,2.81l-1.88.45c-.81.16-1,.93-.65,1.31s.82.76,1.12,1.12A1.22,1.22,0,0,1,40,30.88L19.41,49.35H33.64a1.87,1.87,0,0,1,1.79,1.87,1.83,1.83,0,0,1-1.72,1.84H15.31L9.72,58.14H33.79a1.86,1.86,0,0,1,0,3.69H5.62L0,66.89h48.5a1.88,1.88,0,0,1,1.7,1.83,1.76,1.76,0,0,1-1.66,1.88H0v5H48.46A1.84,1.84,0,0,1,50.2,77.6a1.86,1.86,0,0,1-1.77,1.74H0v5.09H63.22a1.78,1.78,0,0,1,1.69,1.91,1.82,1.82,0,0,1-1.69,1.77H17v5.07H63.41c.87,0,1.6,1.06,1.6,1.91a1.82,1.82,0,0,1-1.61,1.79Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,114.35v5.17s6.84,0,10.73,0a27.39,27.39,0,0,0,15.91-5.17Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,105.65v5.06H64.83a27.32,27.32,0,0,0,3.73-5.06Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.85,74.37l0-.27a19.8,19.8,0,0,0-3.32-10.18c-3.82-6-10.53-9.23-18.61-9.13-8.08-.1-14.79,3.13-18.61,9.13A19.8,19.8,0,0,0,488,74.1l0,.27c-1.1,13.17,6.58,22.28,19.66,23.33.78.06,1.54.09,2.3.08s1.51,0,2.3-.08c13.08-1,20.76-10.16,19.66-23.33m-21,17.15c-.35,0-.68,0-1,0s-.66,0-1,0a9,9,0,0,1-4.82-1.92,11,11,0,0,1-1.16-1.12c-2-2.28-3.09-6.14-3.35-9.2-.59-7.12.83-17.52,9.58-18.22l.65,0H510l.65,0c8.74.7,10.18,11.1,9.58,18.22-.26,3.06-1.23,6.85-3.35,9.2a12,12,0,0,1-1.16,1.12,9.1,9.1,0,0,1-4.82,1.92",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.84,64.57c0-3.26.32-9,.32-9H434.42s.32,5.73.32,9l0,23.47c0,3.26-.29,8.81-.29,8.81h10.73s-.3-5.55-.3-8.81Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.18,90.47h-7.46c-.1-4.15-.15-8.16-.17-11.8v-.56h0V78h12.39V72.19H374.56c0-6.28.16-10.42.16-10.42H390.1V55.58c-10.75,0-26.28,0-26.28,0s.23,5.69.23,9V88c0,3-.19,8-.22,8.9h27.28l0-6.56s-5.37.18-8.95.18",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.33,90.47h-7.46c-.1-4.15-.15-8.16-.17-11.79v-.57h0V78h12.39V72.19H195.71c0-6.28.16-10.41.16-10.41h15.38V55.58c-10.75,0-26.28,0-26.28,0s.24,5.7.24,9V88c0,3-.19,8-.22,8.9h27.27l0-6.56s-5.37.18-8.95.18",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.28,74.65l11.85-19.06h-8.21l-.06.18c-2.48,4.29-5.57,9.48-6.8,11.38l-.48.77-6.86-12.33H394.38l11.89,21.34L393.88,96.85H402c5.28-9,8-13.19,8-13.19l7.36,13.19h12.28Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.3,91.23c-9.54,0-14.68-7-14.42-15.65.22-7.53,3.67-13.92,11.86-14.47,3.14-.21,5.7.34,10.11,1.52l-.46-6.45a37.32,37.32,0,0,0-9.07-1.39c-6.81-.27-13,1.05-17.87,5.57a21.86,21.86,0,0,0-7,15.72A20.89,20.89,0,0,0,459,92.43c5.12,4.32,10.62,5.29,17.15,5.29a36.17,36.17,0,0,0,11-1.41L486.53,90a25.56,25.56,0,0,1-8.23,1.25",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5,49.4h12l.33,2.76c2.67,27.57,4.31,44.71,4.31,44.71H344.66l-1.24-17.08-1.14-15.26L331.74,96.85h-6.66s-3.34-11.49-3.95-13.1l-6-19.38s-.92,10.79-1.29,15.41c-.72,9.26-1.37,17.08-1.37,17.08h-9.29s3.8-38.59,4.09-40.94.74-6.52.74-6.52h12.21L330.3,77.19Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.13,74.43l0-.28A19.73,19.73,0,0,0,294.8,64c-3.81-6-10.49-9.19-18.53-9.09-8-.1-14.72,3.12-18.53,9.09a19.73,19.73,0,0,0-3.3,10.13,1.27,1.27,0,0,0,0,.28C253.31,87.54,261,96.61,274,97.65c.78.06,1.54.09,2.29.09s1.51,0,2.29-.09c13-1,20.67-10.11,19.57-23.22M277.28,91.5c-.35,0-.68,0-1,0s-.65,0-1,0a9,9,0,0,1-4.79-1.91,10.16,10.16,0,0,1-1.15-1.13c-2-2.26-3.09-6.11-3.35-9.15-.59-7.09.84-17.44,9.54-18.14l.66,0h.2l.65,0c8.72.7,10.14,11,9.54,18.14-.25,3-1.23,6.82-3.34,9.15a11.07,11.07,0,0,1-1.15,1.13,9.16,9.16,0,0,1-4.79,1.91",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.38,96.85c-.35-.85-2.57-6.09-4.19-10.32L164.24,49.4H153.39s-3.1,8.69-3.54,10.14l-10.18,28.8c-1.34,3.68-3.18,8.51-3.18,8.51h8.86s2.51-8,3-9.45l1.37-4H165.1l2.09,6.1c.44,1.15,2.26,7.26,2.29,7.36ZM152,76.64l5.18-15.37.29-.9,5.41,16.27Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,96.85c-2.56-3.68-3.5-5.21-5.47-7.92l-7.4-11.49a12.34,12.34,0,0,0,7.4-10.86,10.57,10.57,0,0,0-3-8.14,10,10,0,0,0-6-2.52c-2-.25-3.4-.28-4.58-.36H218.52s.21,5.71.21,9V87.87c0,3.26-.21,9-.21,9h10.72s-.32-5.71-.32-9l.08-7.49h4l6.79,12.44c.91,1.58,2.22,3.56,2.53,4ZM236,73.81c-1.6.84-5.21.6-7,.49l.14-11.79,1-.07a15.88,15.88,0,0,1,6.68.62c1.46.66,2.33,2,2.41,4.37.12,3.48-1.2,5.34-3.23,6.38",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.72,92.81a4.06,4.06,0,1,1,4.06,4.07,4.06,4.06,0,0,1-4.06-4.07m7.13,0a3.08,3.08,0,1,0-3.07,3.28,3.11,3.11,0,0,0,3.07-3.28m-4.63-2.31h1.71c1.1,0,1.7.38,1.7,1.35a1.14,1.14,0,0,1-1.21,1.23l1.24,2h-.88l-1.19-2h-.52v2h-.85Zm.85,2h.75c.51,0,.95-.07.95-.69s-.5-.63-.94-.63h-.76Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.91,108.47c-80-17.41-114.1,10-114.1,10s37.23-22,114.06-5.32C496.26,130.15,532,101,532,101S492.15,124.62,417.91,108.47Z",
    style: {
      fill: "#e91b2f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpoAm);
export default __webpack_public_path__ + "static/media/gpo-am.1630cd3a2ef72817b95bddcb68b579db.svg";
export { ForwardRef as ReactComponent };